export function togglePassword() {
    let passwordInputs = document.querySelectorAll('[data-togglePassword]');

    passwordInputs.forEach(passwordInput => {
        let input = passwordInput.querySelector('input[type=password]');
        let toggleBtn = passwordInput.querySelector('[data-togglePasswordBtn]');

        function toggle() {
            if (input.getAttribute('type') == 'password') {
                input.setAttribute('type', 'text');
            } else {
                input.setAttribute('type', 'password');
            }
        }

        toggleBtn.addEventListener('click', toggle);
    })
}
